import React, { useState, useEffect, useRef } from "react";

import Leftsidebar from "../sidebar/leftsidebar";
import LeftResponsivesidebar from "../sidebar/left-responsive";
import Headmenu from "../sidebar/headmenu";

import {
  BsCameraVideoOffFill,
  BsMicMute,
  BsMicMuteFill,
  BsFillCameraVideoFill,
} from "react-icons/bs";
import { Switch } from "@headlessui/react";
import Webcam from "react-webcam";
import { TbWorld } from "react-icons/tb";
import { AiOutlineExport } from "react-icons/ai";
import { IoBagHandleOutline } from "react-icons/io5";
import like from "../../assets/images/icons/like.png";

const CustomView = () => {
  const [cameraOn, setCameraOn] = useState(false);
  const [micOn, setMicOn] = useState(false);
  const [commentsEnabled, setCommentsEnabled] = useState(false);
  const webcamRef = useRef(null);

  const [deviceId, setDeviceId] = React.useState({});
  const [devices, setDevices] = React.useState([]);
  const [isLive, setIsLive] = useState(false); // Tracks Go Live state

  const liveChatMessages = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 3,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 4,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 5,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 6,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 7,
      name: "Ralph Edwards",
      time: "12:20 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 8,
      name: "Ralph Edwards",
      time: "12:21 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
    {
      id: 9,
      name: "Ralph Edwards",
      time: "12:22 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa. ",
    },
  ];

  const products = [
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },

    {
      name: "Adidas 4DFWD x Parley Running Shoes",
      image: "/image/shoeimg.png",
      originalPrice: 444.0,
      discountPrice: 333.2,
      offer: "12% Offer",
    },
  ];

  const handleDevices = React.useCallback(
    (mediaDevices) =>
      setDevices(mediaDevices.filter(({ kind }) => kind === "videoinput")),
    [setDevices]
  );

  React.useEffect(() => {
    navigator.mediaDevices.enumerateDevices().then(handleDevices);
  }, [handleDevices]);

  console.log(webcamRef);
  console.log(deviceId);

  const comments = [
    {
      id: 1,
      name: "Ralph Edwards",
      time: "12:30 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
      avatar: "/image/profilepic.png",
    },
    {
      id: 2,
      name: "Ralph Edwards",
      time: "12:30 PM",
      message:
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aenean commodo ligula eget dolor. Aenean massa.",
      avatar: "/image/profilepic.png",
    },
  ];
  return (
    <div className="dashboard w-full min-h-screen flex">
      <Leftsidebar />

      <main className="flex-1  p-6">
        <LeftResponsivesidebar />
        <Headmenu />
        <div className="mt-6 w-full  flex gap-4">
          <div className="bg-[#EBF8ED] w-[70%]">
            <div className="w-[100%] flex">
              <div
                className={`bg-black relative rounded-lg h-[400px] flex flex-col justify-center items-center text-white
                w-[100%]
              `}
              >
                {cameraOn ? (
                  <div className="relative">
                    <Webcam
                      ref={webcamRef}
                      audio={false}
                      videoConstraints={{ deviceId: devices.deviceId }}
                      className="rounded-md w-full   h-[400px]"
                    />
                    <div className="absolute bottom-0  px-0 w-[100%]">
                      <div className="flex p-3 justify-between items-center">
                        <p className="">100K Viewers</p>
                        <div>
                          <button className="bg-red-800 text-white px-6 py-1 rounded-full">
                            Live
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="flex flex-col justify-center items-center text-white">
                    <div className="absolute top-0 left-0 px-0 w-[100%]">
                      <div className="flex justify-between ">
                        <div className="flex gap-3 p-2 bg-[#D9D9D980]  rounded-br-3xl">
                          <div className="bg-white p-2  w-[50px] h-[50px] rounded-full">
                            <img
                              src="/image/wanchain.png"
                              alt="logo"
                              className="w-[40px] h-[40px] object-contain"
                            />
                          </div>
                          <div className="text-black ">
                            <p className="font-semibold text-xl">
                              {" "}
                              SKY Products
                            </p>
                            <p className="text-md">{"27 Jan 2025, 12:30 PM"}</p>
                          </div>
                        </div>

                        <div>
                          <button className="p-2 bg-[#D9D9D980] rounded-b-md mr-8">
                            <AiOutlineExport className="text-[18px] text-black" />
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="text-4xl mb-4">
                      <BsCameraVideoOffFill />
                    </div>
                    <p className="text-lg font-semibold">
                      Allow Access To Camera
                    </p>
                  </div>
                )}
              </div>
            </div>

            <div className="mt-3 flex justify-between items-center  p-4 rounded ">
              <div className="flex gap-4 items-center ">
                <button
                  onClick={() => {
                    setCameraOn((prev) => !prev);

                    // OPTIONAL: stop the stream when turning off
                    const videoEl = webcamRef.current?.video;
                    if (videoEl && videoEl.srcObject) {
                      const stream = videoEl.srcObject;
                      const tracks = stream.getTracks();
                      tracks.forEach((track) => track.stop());
                    }
                  }}
                  className="text-xl bg-white rounded-full p-3"
                >
                  {cameraOn ? (
                    <BsFillCameraVideoFill className="text-gray-400" />
                  ) : (
                    <BsCameraVideoOffFill className="text-gray-400" />
                  )}
                </button>
                <button
                  onClick={() => setMicOn(!micOn)}
                  className="text-xl bg-white rounded-full p-3"
                >
                  {micOn ? <BsMicMuteFill /> : <BsMicMute />}
                </button>
                {/* <div className="flex items-center gap-2">
                  <Switch
                    checked={commentsEnabled}
                    onChange={setCommentsEnabled}
                    className={`${
                      commentsEnabled ? "bg-green-800" : "bg-gray-300"
                    } relative inline-flex h-6 w-11 items-center rounded-full`}
                  >
                    <span
                      className={`${
                        commentsEnabled ? "translate-x-6" : "translate-x-1"
                      } inline-block h-4 w-4 transform bg-white rounded-full transition`}
                    />
                  </Switch>
                  <span className="text-sm">Comments</span>
                </div> */}
              </div>
            </div>
          </div>{" "}
          {/* comments  */}
          {/* <div className="w-[30%]">
            <div className="max-w-sm w-full mx-auto p-4 bg-white rounded-2xl shadow">
              <div className="space-y-4 max-h-[450px] overflow-y-auto pr-2">
                {comments.map((comment) => (
                  <div key={comment.id} className="flex gap-3 border-b-2 pb-2">
                    <img
                      src={comment.avatar}
                      alt={comment.name}
                      className="w-10 h-10 rounded-full object-cover"
                    />
                    <div>
                      <div className="flex items-center justify-between text-sm">
                        <span className="font-semibold">{comment.name}</span>
                        <span className="text-gray-400 ml-2">
                          {comment.time}
                        </span>
                      </div>
                      <p className="text-gray-600 text-sm mt-1">
                        {comment.message}
                      </p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-4 flex items-center border border-gray-300 rounded-full px-3 py-2 bg-white">
                <input
                  type="text"
                  placeholder="Add a comment"
                  className="flex-grow outline-none text-sm placeholder-gray-500"
                />
                <button className="bg-gradient-to-l from-[#08AEEA] to-[#1DE78B]  text-white text-sm font-medium px-4 py-1 rounded-full hover:bg-cyan-600 transition ml-2">
                  Send
                </button>
              </div>
            </div>{" "}
          </div> */}
          <div className="golive-chatbox bg-[#F9FAFB] p-4   h-[500px] rounded-lg relative">
            <div className="absolute top-0 right-0 w-full h-[50%]  rounded-lg z-10 bg-gradient-to-t from-[#ffffff00] to-[#ffffff] pointer-events-none" />

            <div className="h-full overflow-y-auto space-y-4 relative scrollbar-hidden">
              {/* White Shade Blur Effect */}

              {liveChatMessages.map((chat) => (
                <div key={chat.id} className="px-3 py-1 rounded-md">
                  <div className="flex">
                    <div>
                      <img
                        src="/image/profilepic.png"
                        alt={chat.name}
                        className="w-9 rounded-full"
                      />
                    </div>
                    <div className="pl-2">
                      <p className="font-semibold">{chat.name}</p>
                      <p className="text-[8px] text-[#000000]">{chat.time}</p>
                    </div>
                  </div>
                  <p className="text-[12px] break-words pt-2">{chat.message}</p>
                  <hr className="mt-2 pt-[1px] bg-[#D9D9D9]" />
                </div>
              ))}
            </div>
            {/* Add Comment Input */}
            <div className="flex items-center mt-4 w-full absolute bottom-2 right-0">
              <div className="relative flex w-full mx-2">
                <input
                  type="text"
                  placeholder="Add a comment"
                  className="flex-1 p-3 border border-gray-300 rounded-full focus:outline-none"
                />
                <button className="bg-blue-500 text-white px-4 py-2 rounded-full go-to-live-CTA absolute right-1 top-1">
                  Send
                </button>
              </div>
              {/* Show Like Button only when live */}
              {isLive && (
                <button className="bg-[#BE1F2E] text-white px-3 mx-2 py-3 rounded-full">
                  <img src={like} alt="Like" />
                </button>
              )}
            </div>
            {/* Footer */}
            <div className="lg:hidden">
              <div className="copy-rights pb-5 text-center text-sm text-[#095228]">
                © 2025 Pipaan. All Rights Reserved
              </div>
            </div>
          </div>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {products.map((product, index) => (
            <ProductCard product={product} key={index} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default CustomView;

function ProductCard({ product }) {
  return (
    <div className=" p-2">
      <div className="relative bg-[#FAFAFA]">
        <div className="w-full h-[170px] object-contain">
          <img
            src={product.image}
            alt={product.name}
            className="w-full h-full object-contain"
          />
        </div>

        {product.offer && (
          <span className="absolute top-2 left-2 bg-red-600 text-white text-xs px-2 py-1 rounded">
            {product.offer}
          </span>
        )}
      </div>

      <p className="mt-4 text-sm text-gray-600 uppercase">{product.name}</p>

      <div className="flex flex-row  justify-between ">
        <div className="flex flex-col">
          <span className="line-through text-gray-400 text-sm">
            ${product.originalPrice}
          </span>
          <span className="text-black font-semibold">
            ${product.discountPrice}
          </span>
        </div>
        <button className="mt-3 flex py-2 px-2 text-[16px] gap-4 items-center  bg-gray-900 text-white  rounded-full  ">
          <IoBagHandleOutline className="text-lg" />
          Add to Cart
        </button>
      </div>
    </div>
  );
}
